import { IconClock } from 'central-icons/IconClock';
import { IconMapPin } from 'central-icons/IconMapPin';
import { format as d3Format } from 'd3-format';

import styles from './profile-header.module.css';

interface ProfileHeaderProps {
  currentTitle: string;
  yearsOfExperience?: number;
  location?: string;
}

export const ProfileHeader = ({
  currentTitle,
  yearsOfExperience,
  location,
}: ProfileHeaderProps) => {
  return (
    <div className={styles.header}>
      <span>{currentTitle}</span>
      {!!yearsOfExperience && (
        <span className={styles.fact}>
          <span className={styles.icon}>
            <IconClock size={16} />
          </span>
          <span>
            {String(d3Format('.1~f')(Number(yearsOfExperience))) + ' Years'}
          </span>
        </span>
      )}
      {location && (
        <span className={styles.fact}>
          <span className={styles.icon}>
            <IconMapPin size={16} />
          </span>
          <span>{location}</span>
        </span>
      )}
    </div>
  );
};
